<script>
  import { DOWNLOAD_ICON, UPLOAD_ICON } from '@utils/icons.js';
  import { ROUTES } from '@utils/routes.js';
  import { Button  } from "paxray-components-svelte";

  export let idproject;
  export let exportPreprocessingSteps;
  export let importPreprocessingSteps;
  export let downloadAppOverviewAll;
</script>

<!-- @Adrian please add function for testing all rules -->
<Button
  text="Test All Rules"
  kind="secondary"
  disabled
  on:click={downloadAppOverviewAll}
/>
<Button
  text="Export Rules"
  on:click={exportPreprocessingSteps}
  iconLeft={true}
  icon={DOWNLOAD_ICON}
  kind="secondary"
/>
<Button
  text="Import Rules"
  on:click={importPreprocessingSteps}
  iconLeft={true}
  icon={UPLOAD_ICON}
  kind="secondary"
/>
<Button
  text="Anonymization Assistant"
  on:click={() => {
    window.open(
      `${ROUTES.dam.anonymizationAssistant}?idproject=${idproject}&step=2`,
      "_blank"
    );
  }}
  kind="secondary"
/>
